import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import './project-item.scss';

interface ProjectItemProps {
  image: any;
  slug: string;
  title: string;
  description?: string;
  large?: boolean;
  showLogo?: boolean;
  logoPosition?: 'left' | 'right';
  alt?: string;
}

const ProjectItem = ({
  image, slug, title, description, large, showLogo, logoPosition, alt,
} : ProjectItemProps) => {
  let imageComponent = <img src={image.publicURL} alt={alt || ''} />;

  if (image.extension !== 'svg') {
    imageComponent = <GatsbyImage image={getImage(image)} alt={alt || ''} />;
  }

  const viewProjectLink = (
    <span className="project-item-link-wrapper">
      <Link to={`/work/${slug}`} className="project-item-link">View project</Link>
      {' →'}

    </span>
  );
  return (
    <div className={`project-item${large ? ' --large' : ''}`}>
      <div className="project-item-image">
        <Link to={`/work/${slug}`}>
          {imageComponent}
        </Link>
        {showLogo ? (
          <div className={`hero-video-logo --${logoPosition}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 181 254">
              <circle cx="54" cy="127" r="127" fill="#FBE072" />
              <path fill="#000" d="M6.8 46a5.42 5.42 0 01-7.62-1.99 5.42 5.42 0 011.99-7.6c2.68-1.58 6-.86 7.65 1.96A5.45 5.45 0 016.79 46zM41 31.16l-.43-2.75 8.97-1.4.27 1.7c1.03 6.62-2.5 11.56-8.56 12.51-6.46 1.02-12.18-3.22-13.4-10.98-1.21-7.76 2.97-13.55 9.32-14.54 5.3-.83 9.24 1.65 10.97 6.1l-3.19.5c-1.5-2.74-3.82-4.29-7.33-3.74-4.81.76-7.5 5.24-6.57 11.18.93 5.94 4.83 9.43 9.76 8.65 4.32-.67 6.44-3.78 6.13-8.16l-5.94.93zM64.86 40.98c-6.53-.84-10.55-6.76-9.6-14.27.98-7.54 6.36-12.21 12.9-11.37 6.56.84 10.6 6.72 9.62 14.27-.96 7.5-6.35 12.21-12.92 11.37zm2.92-22.76c-4.78-.62-8.56 3.06-9.3 8.9-.76 5.85 1.96 10.36 6.75 10.98 4.83.62 8.6-3.06 9.35-8.9.75-5.85-1.97-10.36-6.8-10.98zM88.56 47.5c-6.03-2.62-8.24-9.43-5.21-16.37 3.04-6.97 9.51-9.95 15.55-7.31 6.07 2.64 8.3 9.41 5.25 16.39-3.02 6.93-9.51 9.95-15.59 7.3zm9.17-21.02c-4.42-1.93-9.07.55-11.42 5.95-2.36 5.4-1 10.49 3.41 12.42 4.47 1.94 9.12-.54 11.47-5.94 2.35-5.4 1-10.49-3.46-12.43zM118.04 34.48l6.2 5.14c5.67 4.7 6.26 11.55 1.38 17.44-4.88 5.9-11.73 6.6-17.4 1.9l-6.2-5.15 16.02-19.33zm-8 22.21c4.38 3.63 9.36 2.87 13.12-1.66 3.76-4.54 3.6-9.6-.77-13.23l-3.69-3.06-12.34 14.9 3.68 3.05zM136.63 76.12l-8.83 4.82-1.55-2.84 22.05-12.02 4.5 8.26c2.43 4.46 1.7 8.5-2.65 10.86-4.3 2.35-8.13.8-10.56-3.65l-2.96-5.43zm13.66-.5l-2.92-5.35-8.22 4.48 2.91 5.35c1.63 2.99 4.09 3.65 6.56 2.3 2.52-1.37 3.3-3.8 1.67-6.78zM146.77 96.85l-10.28 2.72-.83-3.13 24.28-6.42 2.38 9.02c1.29 4.86-.35 8.6-4.93 9.8-4.04 1.07-6.96-.7-8.48-4.35l-8.5 9.9-.94-3.55 8.44-9.68-1.14-4.31zm2.64-.7l1.54 5.8c.85 3.21 2.93 4.52 5.62 3.81 2.69-.71 3.85-2.88 3-6.08l-1.53-5.81-8.63 2.28zM165.67 131.2l-25.38 9.08.1-3.27 7.64-2.68.3-10.35-7.48-3.08.09-3.27 24.82 10.54-.09 3.02zm-14.55-6.07l-.24 8.18 10.83-3.78-10.6-4.4zM147.68 160.08l-15.02 4.36 1.17-3.5 11.96-3.48-7.43-9.96 1.13-3.38 9.27 12.49 14.43-4.17-1.17 3.5-11.4 3.23 7.1 9.55-1.14 3.38-8.9-12.02zM128.77 170.37l1.58-2.81 21.9 12.27-1.57 2.82-21.9-12.28zM129.78 181.16c-2.75-1.05-5.33-.1-7.29 2.25-2.08 2.52-2.31 5.3-.17 7.08 1.51 1.25 3.2 1.2 5.61-.56l3.78-2.7c2.91-2.11 5.88-2.94 8.81-.52 3.28 2.71 3.24 7.25.22 10.9-3.31 4-7.32 4.67-10.97 2.87l2.06-2.5c2.22.84 4.68.44 6.8-2.11 1.9-2.3 2.11-5 .13-6.64-1.64-1.35-3.31-.94-5.52.64l-3.59 2.6c-3.34 2.44-6.45 2.79-9.19.52-3.5-2.9-3.26-7.48-.08-11.32 3.19-3.85 7.48-5.12 11.48-3.03l-2.08 2.52zM101.04 207.21a5.42 5.42 0 017.6 2 5.42 5.42 0 01-2 7.61 5.45 5.45 0 01-7.64-1.98 5.45 5.45 0 012.04-7.63zM68.46 221.74l.48 2.74-8.95 1.54-.3-1.7c-1.13-6.6 2.32-11.6 8.37-12.64 6.44-1.11 12.22 3.04 13.56 10.78 1.33 7.73-2.76 13.59-9.1 14.68-5.27.9-9.26-1.52-11.06-5.94l3.19-.55c1.54 2.72 3.88 4.23 7.39 3.63 4.8-.83 7.42-5.35 6.4-11.28-1.03-5.92-4.98-9.35-9.9-8.5-4.31.74-6.38 3.88-6 8.26l5.92-1.02zM44.46 212.29c6.54.74 10.66 6.6 9.8 14.11-.84 7.56-6.16 12.31-12.7 11.57-6.58-.74-10.7-6.56-9.85-14.12.85-7.51 6.17-12.3 12.75-11.56zm-2.57 22.8c4.8.54 8.5-3.2 9.17-9.05.66-5.85-2.13-10.33-6.92-10.87-4.84-.54-8.56 3.2-9.22 9.05-.66 5.85 2.13 10.32 6.97 10.87zM20.66 206.11c6.08 2.54 8.39 9.31 5.47 16.3-2.93 7.02-9.36 10.1-15.43 7.55-6.12-2.55-8.45-9.29-5.51-16.3 2.92-6.99 9.36-10.1 15.47-7.55zm-8.84 21.17c4.45 1.86 9.06-.69 11.33-6.12 2.27-5.43.85-10.5-3.6-12.37-4.5-1.87-9.11.68-11.38 6.11-2.27 5.44-.84 10.5 3.65 12.38zM-8.6 219.6l-6.29-5.04c-5.74-4.61-6.43-11.46-1.64-17.42 4.79-5.97 11.63-6.77 17.37-2.16l6.28 5.04L-8.6 219.6zm7.65-22.33c-4.43-3.56-9.4-2.73-13.1 1.86-3.68 4.6-3.45 9.66.99 13.22l3.73 3 12.11-15.09-3.73-3z" />
            </svg>
          </div>
        ) : '' }
      </div>
      <div className="project-details-wrapper">
        <div className="project-details">
          <div className="project-item-title">
            <Link to={`/work/${slug}`}>
              {large ? '↑ ' : ''}
              {title}
            </Link>
            {' '}
            {large ? (
              <>
                –
                {' '}
                {description}
                {' '}
                {viewProjectLink}
              </>
            ) : ''}
          </div>
          { !large && description ? (
            <div className="project-item-description">
              {description}
              {' '}
              {viewProjectLink}
            </div>
          ) : '' }
        </div>
      </div>
    </div>
  );
};

ProjectItem.defaultProps = {
  large: false,
  showLogo: false,
  description: null,
  logoPosition: 'left',
  alt: '',
};

export default ProjectItem;
